import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import {
  Copy as CopyIcon,
  Check as CheckIcon
} from '@geist-ui/icons';

export default function Copy({content, ariaDescription, classDefinition}) {
  const [copied, setCopied] = useState(false)

  const variants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1 },
  }

  const transition = {
    duration: 0.2,
    delay: 0
  }

  const copy = () => {
    navigator.clipboard.writeText(content)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <button aria-label={ariaDescription} onClick={copy} className={classDefinition}>
      <AnimatePresence mode="wait" initial={false}>
        { copied ? (
          <motion.span
            key="checkmark"
            transition={transition}
            variants={variants}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            <CheckIcon size={16}/>
          </motion.span>
        ) : (
          <motion.span
            key="copy"
            transition={{
              duration: 0,
              delay: 0
            }}
            variants={variants}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            <CopyIcon size={16}/>
          </motion.span>
        )}
      </AnimatePresence>
    </button>
  )
}
